import Head from 'next/head';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';
import FAQ from '../utils/faq.json';
import { Accordion, AccordionItem } from 'react-light-accordion';
import 'react-light-accordion/demo/css/index.css';
import { Fade } from "react-awesome-reveal";

function Support() {
    return (
        <div>
            <Head>
                <title>Lindle Support</title>
                <meta name="description" content="All your links, All at once, All in one place!" />
                <link rel="icon" href="/favicon.ico" />

                {/* Facebook */}
                <meta property="og:title" content="Lindle" />
                <meta property="og:description" content="All your links, All at once, All in one place!" />
                <meta property="og:image" content="/logoText.png" />
                <meta property="og:url" content="https://lindle.vercel.app" />
                <meta property="og:type" content="website" />

                <meta name="twitter:title" content="Lindle" />
                <meta name="twitter:description" content="All your links, All at once, All in one place!" />
                <meta name="twitter:image" content="/logoText.png" />
                <meta name="twitter:card" content="/bannerText.png" />

                {/* pinterest */}
                <meta name="pinterest-rich-pin" content="true" />
            </Head>


            {/* Navigation */}
            <Navigation />

            {/* Main Content Section */}
            <main className="container mx-auto my-8 p-8 bg-white shadow-lg rounded-lg">

                {/* Contact / Support */}
                <section className='phone:w-full tablet:w-9/12 mx-auto my-8'>

                    <h2 className='font-bold mobile:text-3xl tablet:text-5xl text-lime-800 my-6'>Contact Lindle Support</h2>

                    <p className='mb-4'>If you need help, please email us at <a href="mailto:lindle@m2kdevelopments.com" className="text-lime-700 underline">lindle@m2kdevelopments.com</a>.</p>

                    <p className='mb-2'>To help us resolve your issue faster, include the following when you contact support:</p>

                    <ul className='list-disc list-inside mb-4'>
                        <li>Your Lindle account email</li>
                        <li>A short description of the issue and the expected behavior</li>
                        <li>Steps to reproduce the issue</li>
                        <li>Screenshots or screen recordings (if possible)</li>
                    </ul>

                    <p className='mb-2'>We aim to respond within 24–72 hours on business days. For urgent account or billing issues, please include "URGENT" in the subject line.</p>

                    <p className='mb-0'>Thanks — we’re here to help.</p>

                </section>

                {/* FAQ */}
                <section className='phone:w-full tablet:w-9/12 mx-auto my-14'>

                    <h2 className='font-bold mobile:text-3xl tablet:text-6xl text-lime-800 my-12'>Frequently Asked Questions</h2>

                    <Accordion atomic={true}>
                        {
                            FAQ.map((faq, index) =>
                                <Fade damping={1.0} key={index}>
                                    <AccordionItem title={faq.question}>
                                        <p>{faq.answer}</p>
                                    </AccordionItem>
                                </Fade>
                            )
                        }
                    </Accordion>
                </section>

            </main>

            <Footer />
        </div>
    )
}

export default Support
